import { render, staticRenderFns } from "./filtersComp.vue?vue&type=template&id=219a956e"
import script from "./filtersComp.vue?vue&type=script&lang=js"
export * from "./filtersComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports